export class RelaxLogicEvents {
	public static readonly REPLAY_RESPONSE: string = 'RelaxLogicEvents::REPLAY_RESPONSE';
	public static readonly REPLAY_HTTP_RESPONSE: string = 'RelaxLogicEvents::REPLAY_HTTP_RESPONSE';
	public static readonly REALITY_CHECK_RECIEVED_IN_RESPONSE: string = 'RelaxLogicEvents::REALITY_CHECK_RECIEVED_IN_RESPONSE';
	public static readonly FREE_ROUNDS_SKIPPED: string = 'RelaxLogicEvents::FREE_ROUNDS_SKIPPED';
	public static readonly FREE_ROUNDS_DELETED: string = 'RelaxLogicEvents::FREE_ROUNDS_DELETED';
	public static readonly CLIENT_CONFIG_RESPONSE: string = 'RelaxLogicEvents::CLIENT_CONFIG_RESPONSE';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/relax/RelaxLogicEvents.ts